module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"level":"Nivå"},"en":{"level":"Level"}}')
  delete Component.options._Ctor
}
